import { Box, Flex } from "monday-ui-react-core";

import { BorderedBox } from "@/components/Common";

import { StatusRow } from "./StatusRow";

type Props = {
  success: boolean;
  results?: string;
  duration?: number;
};

export function ResultBox({ success, results, duration }: Props) {
  return (
    <Box marginTop={Box.marginTops.XXL}>
      <Flex direction={Flex.directions.COLUMN} align={Flex.align.STRETCH} gap={Flex.gaps.SMALL}>
        <StatusRow success={success} duration={duration} />

        <BorderedBox backgroundColor={Box.backgroundColors.ALL_GREY_BACKGROUND_COLOR} paddingX={Box.paddingXs.LARGE}>
          <pre
            style={{
              fontSize: 14,
              height: 200,
              lineHeight: "var(--font-line-height-10)",
              overflow: "scroll",
            }}
          >
            {results}
          </pre>
        </BorderedBox>
      </Flex>
    </Box>
  );
}
